import { createSlice, combineReducers } from '@reduxjs/toolkit'
import { LoanOfficersServerData, AppOfficersServerData } from '@lk/api'

import { loadOfficerList, loadAppList, loadAvailableOfficerList } from './loanOfficer.actions'

export interface InitialOfficerListState {
  status: 'idle' | 'loading' | 'loaded' | 'failed'
  error: string
  officers: LoanOfficersServerData | null
  apps: AppOfficersServerData | null
}

const initialOfficerListState: InitialOfficerListState = {
  status: 'idle',
  error: null,
  officers: null,
  apps: null,
}

export const listReducer = createSlice({
  name: 'officerList',
  initialState: initialOfficerListState,
  reducers: {},
  extraReducers: {
    [loadOfficerList.pending.toString()]: (state) => {
      state.status = 'loading'
    },
    [loadAppList.pending.toString()]: (state) => {
      state.status = 'loading'
    },
    [loadOfficerList.fulfilled.toString()]: (state, action) => {
      state.status = 'loaded'
      state.officers = action.payload
    },
    [loadAppList.fulfilled.toString()]: (state, action) => {
      state.status = 'loaded'
      state.apps = action.payload
    },
    [loadOfficerList.rejected.toString()]: (state, action) => {
      state.status = 'failed'
      state.error = action.payload
    },
    [loadAppList.rejected.toString()]: (state, action) => {
      state.status = 'failed'
      state.error = action.payload
    },
  },
}).reducer

export interface InitialAvailableOfficerListState {
  status: 'idle' | 'loading' | 'loaded' | 'failed'
  error: string
  data: LoanOfficersServerData | null
}

const initialAvailableOfficerListState: InitialAvailableOfficerListState = {
  status: 'idle',
  error: null,
  data: null,
}

export const availableReducer = createSlice({
  name: 'availableOfficerList',
  initialState: initialAvailableOfficerListState,
  reducers: {},
  extraReducers: {
    [loadAvailableOfficerList.pending.toString()]: (state) => {
      state.status = 'loading'
    },
    [loadAvailableOfficerList.fulfilled.toString()]: (state, action) => {
      state.status = 'loaded'
      state.data = action.payload
    },
    [loadAvailableOfficerList.rejected.toString()]: (state, action) => {
      state.status = 'failed'
      state.error = action.payload
    },
  },
}).reducer

export const loanOfficerReducer = combineReducers({
  list: listReducer,
  available: availableReducer,
})
